export const BULK_INVOICE_EXCEL_TEMPLATE_URL =
  "https://inkle-django-files.s3.ap-south-1.amazonaws.com/Template+-+Add+Invoices+in+Bulk.xlsx";

export const BULK_JOURNAL_ENTRY_EXCEL_TEMPLATE_URL =
  "https://inkle-django-files.s3.ap-south-1.amazonaws.com/Template+-+Add+Journal+Entries+in+Bulk.xlsx";

export const BULK_SALES_TAX_INVOICE_EXCEL_TEMPLATE_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/Template+-+Add+Invoices+in+Bulk+for+Sales+Tax+Nexus+Tracking+(1).xlsx";
